import React from 'react';
import Container from '../Layout/Container';
import { Box, Flex } from '../Layout';
import Image from '../Image';
import { Link } from '../Typography';
import abf4allLogo from '../images/abf-logo-abf4all.png';

const Play = () => (
  <Container>
    <Flex flexDirection={['column', 'row']}>
      <Box mr={10}>
        <h1>Play</h1>
        <Image src={abf4allLogo} alt="ABF4ALL Logo" />
        <p>
          Australian Blind Football 4 All, or ABF4ALL, is a new initiative of Australian Blind Football. ABF4ALL aims to
          increase grassroots participation in football by people who are blind or partially sighted, regardless of age,
          gender or ability.
        </p>

        <p>
          We believe people who are blind and partially sighted should be integrated into mainstream football clubs as
          this will increase awareness of people who are blind or partially sighted within the football (and broader)
          community. There are also benefits to blind and partially sighted participants who will take up this
          opportunity as they will become part of a club and enjoy all of the physical and social benefits that this
          brings. We want a true partnership whereby blind and partially sighted football, and footballers, become
          members of a football club.
        </p>

        <p>
          Therefore, Australian Blind Football is partnering with community football clubs and State Football
          Federations in Adelaide, Brisbane, Melbourne, Perth and Sydney. The following are partner clubs for 2021:
        </p>

        <ul>
          <li>
            <Link href="https://www.adelaidecomets.com.au/?v=ef10366317f4" alt="Adelaide Comets Football Club Link">
              Adelaide Comets Football Club
            </Link>
          </li>
          <li>
            <Link href="http://olympicfc.net.au/" alt="Brisbane Olympic Football Club Link">
              Brisbane Olympic Football Club
            </Link>
          </li>
          <li>
            <Link href="http://perthsc.com.au/" alt="Perth Soccer Club Link">
              Perth Soccer Club
            </Link>
          </li>
          <li>
            <Link href="https://www.smfc.com.au/" alt="South Melbourne Football Club Link">
              South Melbourne Football Club
            </Link>
          </li>
          <li>Blind and Low Vision Football NSW</li>
        </ul>

        <p>
          Australian Blind Football also aims to expand its reach over the coming years into other areas, including
          Tasmania, Northern Territory, Canberra, Northern New South Wales and North Queensland.
        </p>

        <p>
          To register your interest and to be put in contact with your local club complete the registration form at the
          following link:
        </p>
        <p>
          <Link href="https://form.jotform.com/202222655484857" alt="Register your interest Link">
            Register your interest here
          </Link>
        </p>
      </Box>
    </Flex>
  </Container>
);

export default Play;



// WEBPACK FOOTER //
// ./src/Play/Play.js